import { render, staticRenderFns } from "./AngebotBanner.vue?vue&type=template&id=0670c81c&scoped=true&"
import script from "./AngebotBanner.vue?vue&type=script&lang=js&"
export * from "./AngebotBanner.vue?vue&type=script&lang=js&"
import style0 from "./AngebotBanner.vue?vue&type=style&index=0&id=0670c81c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0670c81c",
  null
  
)

export default component.exports